import { webApi } from '@mi-front/api-clients';

export type MediaFormat = 'aac' | 'mp3' | 'mpegts';

export type StationType = webApi.StationDtoTypeEnumKey;
export const StationType = webApi.StationDtoTypeEnum;
export type StationAccessType = webApi.StationDtoAccessTypeEnumKey;
export const StationAccessType = webApi.StationDtoAccessTypeEnum;

export type WatermarkConfig = {
  enabled?: boolean;
  imageUrl?: string;
  positionX?: string;
  positionY?: string;
  paddingX?: number;
  paddingY?: number;
  opacity?: number;
};

export interface FragmentTagGroup {
  name: string;
  tags: string[];
  default: boolean;
}

export interface AudiogramTemplate {
  name: string;
  default: boolean;
  data: Record<string, unknown>;
}

/** Station returned by the app API, including its application feature configuration. */
export type Station = webApi.StationDto & {
  format: MediaFormat;
  featuresConfig: FeaturesConfig;
};

type FeaturesConfig = {
  audit: {
    enabled: boolean;
    liveMentionsEnabled: boolean;
  };
  transcription: {
    diarization: { segments: boolean; fragments: boolean };
    enabled: boolean;
  };
  fragments: {
    platformUpload: Record<
      string,
      {
        enabled: boolean;
      }
    >;
    descriptionFooters?: {
      name: string;
      content: string;
      default: boolean;
    }[];
    mediaWatermark?: WatermarkConfig;
    audiogram?: {
      templates: AudiogramTemplate[];
    };
    cfrTranscoding?: {
      enabled: boolean;
    };
    tagGroups?: FragmentTagGroup[];
  };
  streamerBox?: {
    deviceId?: string;
  };
  videoAnalysis: {
    faceRecognition: { enabled: boolean };
    lowerThird: { enabled: boolean };
    adOverlays: { enabled: boolean };
    enabled: boolean;
  };
  export?: {
    enabled?: boolean;
  };
};

export type MinimumStation = webApi.MinStationDto;

export type MinimumStationsGroup = webApi.StationGroupDto;
